<template>
  <el-card class="box-card">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/envios' }"
        >Notificaciones</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="$route.params.id"
        >Editando Notificación</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else>Nueva Notificación</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <h2>{{ form.asunto }}</h2>
    <el-form @submit.native.prevent="submit" ref="form" label-position="top" id="form">
      <el-row>
        <el-col>
          <el-form-item label="Asunto">
            <el-input v-model="form.asunto"></el-input>
          </el-form-item> </el-col></el-row
      ><el-row>
        <el-col>
          <el-form-item label="Mensaje">
            <el-input type="textarea" :rows="5" v-model="form.texto"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="Adjunto">
            <el-upload
              :key="reload_upload"
              ref="file"
              action
              :auto-upload="false"
              :multiple="false"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :file-list="documento"
              :limit="1"
            >
              <el-button size="small" type="primary">Clic para cargar archivo</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mb-5">
        <el-col>
          <el-tag type="warning"
            >Para realizar cualquier modificacion en los permisos primero debes elegir los
            permisos, seguidamente debes hacer click en guardar permisos, y por ultimo en
            el boton Guardar.</el-tag
          >
        </el-col>
      </el-row>
      <el-row class="mb-5">
        <el-col>
          <el-form-item label="Destinatarios">
            <app-modal-add-auth
              :table="tableAuth"
              :data="idAuth"
              v-if="showPermisos"
            ></app-modal-add-auth>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row>
      <el-col :span="24">
        <button type="submit" class="el-button el-button--primary" form="form">
          <span>Guardar</span>
        </button>

        <el-button v-if="!$route.params.section_id" @click="close()">Cancelar</el-button>
        <el-button
          v-if="$route.params.id"
          type="warning"
          :disabled="form.enviado != null"
          @click="enviar()"
        >
          Enviar <i class="el-icon-position el-icon-left"></i
        ></el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import notificationform from "@/components/Dashboard/home/notificationform";
import addAuth from "@/components/_commons/auth/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import { Loading } from "element-ui";
import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE,
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";

export default {
  name: "NotificacionesForm",
  components: {
    "app-notification-form": notificationform,
    "app-modal-add-auth": addAuth,
  },
  async created() {
    if (this.$route.params.id) {
      this.init();
    } else {
      this.showPermisos = true;
    }

    for (let i = 1; i < 32; i++) {
      this.dias.push({ label: "Día " + i, value: i });
    }
    this.$root.$on("guardarPermisos", (frm) => {
      this.$message({
        type: "success",
        message: "Permisos actualizados",
      });
      this.frm_permisos = frm;
    });
  },
  data() {
    return {
      isLoading: false,
      frm_permisos: [],
      idAuth: 0,
      tableAuth: "envios",
      showPermisos: false,
      dias: [],
      reload_table: 0,
      fullscreenLoading: false,
      show_procesar: false,
      reload_upload: 0,
      documento: [],
      pickerOptions1: {
        firstDayOfWeek: 1,
      },
      showEditPermisos: true,

      // show,s
      showTabla: false,

      // form
      id: null,
      form: {
        asunto: "",
        texto: "",
        file: "",
      },

      templates: null,
      errorTitle: false,

      // paginate
      tableData: [],
      routeEdit: false,

      tableDelete: false,
      preview: false,

      // notification
      notification: false,
      notification_id: false,
    };
  },
  methods: {
    async enviar() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text:
          "Enviando los emails espere hasta que termine, puede tardar unos minutos dependiendo de los usuarios seleccionados.",
      });
      const response = await ApiService.post("dashboard/notificaciones/envios_to_user", {
        table: "envios",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      loadingInstance.close();
      this.close();
      console.log(this.$route.params.id);
    },
    async init() {
      this.idAuth = parseInt(this.$route.params.id);
      await this.getDesktop();
      this.showPermisos = true;
    },
    handleRemove(file) {
      this.documento = [];
      this.form.file = "";
    },
    handleChange(file) {
      this.documento = [{ file, field: "file" }];
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },

    async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "envios",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      this.form = response.data;
      if (this.form.file != "" && this.form.file != null) {
        this.documento[0] = {
          url: API_UPLOADS + this.form.file,
          name: "Adjunto",
          status: "success",
        };
        this.reload_upload++;
      }
    },
    async uploadFile(data) {
      const response = await ApiService.post("upload/envios", data);
      return response.data;
    },
    async submit() {
      if (this.documento.length > 0) {
        for (const i of this.documento) {
          if (i.file !== undefined && i.file.size) {
            let data = new FormData();
            data.append("file", i.file.raw);
            data.append("type", "file");
            data.append("domain", localStorage.getItem("project"));
            let documento = await this.uploadFile(data);
            this.form.file = documento;
          }
        }
      }

      const response = await ApiService.post("dashboard/editform", {
        table: "envios",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id,
      });
      let id = response.data;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }

      if (this.frm_permisos.length > 0) {
        const resp = await ApiService.put("dashboard/update-desktop-auth", {
          table: "envios",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: this.frm_permisos,
          id: id,
          tableAuth: "envios",
        }).then((response) => {
          if (response.data) {
            this.$message({
              type: "success",
              message: "Permisos actualizados",
            });
          }
        });
      }
      this.$router.replace("/dashboard/" + this.$route.params.db + "/envios");
    },

    async close() {
      await this.$router.replace("/dashboard/" + this.$route.params.db + "/envios");
    },
    loading() {
      this.fullscreenLoading = true;
    },
  },
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/plugins/envios/form.vue